import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import en from './en.json';
import ptBR from './pt-br.json';

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            'pt-BR': { translation: ptBR },
            en: { translation: en },
        },
        fallbackLng: 'en',
        interpolation: { escapeValue: false },
    });

export default i18n;
